import { Route } from "react-router-dom";
import { SimpleErrorBoundary } from "~/components";
import { lazyNamedPage } from "~/utils/routing/lazyPage";
import { StayTablePageLoader } from "./StayTablePage/loaders";
import { ROUTES } from "~/utils";

const StayTablePage = lazyNamedPage("StayTablePage", () =>
  import(
    /* webpackChunkName: "stay" */
    "./StayTablePage/StayTablePage"
  ),
);

export const StayPagesRoutes = () => {
  return (
    <Route
      path={ROUTES.stays}
      loader={StayTablePageLoader}
      ErrorBoundary={() => SimpleErrorBoundary()}
      element={<StayTablePage />}
    />
  );
};
